import {createSlice} from '@reduxjs/toolkit'
import api from "../api";
import {MODAL_VIEW_STATE, VIEW_STATE} from "../utils/enums";
import utils from "../utils";
import toast from "../utils/toast";

const slice = createSlice({
    name: 'class',
    initialState: {
        listViewState: VIEW_STATE.LOADING,
        modalViewState: MODAL_VIEW_STATE.NOT_LOADING,
        viewState: VIEW_STATE.LOADING,
        classes: [],
        hasMore: true,
        classItem:null
    },
    reducers: {
        setViewState: (state, action) => {
            state.viewState = action.payload
        },
        setModalViewState: (state, action) => {
            state.modalViewState = action.payload
        },
        setListViewState: (state, action) => {
            state.listViewState = action.payload
        },
        setClasses: (state, action) => {
            state.hasMore = action.payload.length > 0 && action.payload.length % global.PAGE_SIZE === 0
            state.classes = action.payload
            state.listViewState = VIEW_STATE.LOADED
        },
        setClass: (state, action) => {
            state.classItem= action.payload
            state.viewState = VIEW_STATE.LOADED
        },
        addClasses: (state, action) => {
            state.hasMore = action.payload.length > 0 && action.payload.length % global.PAGE_SIZE === 0
            state.classes = [...state.classes, ...action.payload]
        },
        onError: (state, action) => {
            state.modalViewState = MODAL_VIEW_STATE.NOT_LOADING
            toast.error(action.payload);
        },
    },
});

export default slice.reducer
const {setViewState,setListViewState, setClasses, addClasses,setClass,setModalViewState,onError} = slice.actions

export const getClasses = (page, type) => async dispatch => {
    try {
        if (page === 0) dispatch(setListViewState(VIEW_STATE.LOADING))
        const {data} = await api.classApi.getClasses(page, type)
        if (page === 0) dispatch(setClasses(data?.data));
        else dispatch(addClasses(data?.data));
    } catch (e) {
        dispatch(setListViewState(VIEW_STATE.ERROR))
    }
}
export const getRegisteredClasses = (page) => async dispatch => {
    try {
        if (page === 0) dispatch(setListViewState(VIEW_STATE.LOADING))
        const {data} = await api.classApi.getRegisteredClasses(page)
        if (page === 0) dispatch(setClasses(data?.data));
        else dispatch(addClasses(data?.data));
    } catch (e) {
        dispatch(setListViewState(VIEW_STATE.ERROR))
    }
}
export const getClass = (classId) => async dispatch => {
    try {
        dispatch(setViewState(VIEW_STATE.LOADING))
        const {data} = await api.classApi.getClass(classId)
        dispatch(setClass(data?.data));
    } catch (e) {
        dispatch(setViewState(VIEW_STATE.ERROR))
    }
}
export const paymentRequest = (classId, offCode,onSuccess,t) => async dispatch => {
    try {
        dispatch(setModalViewState(MODAL_VIEW_STATE.LOADING))
        const {data} = await api.classApi.paymentRequest(classId, offCode)
        onSuccess(data?.data)
        dispatch(setModalViewState(MODAL_VIEW_STATE.NOT_LOADING))
    } catch (e) {
        const message = e.response?.data?.message ?? t("errorInConnection")
        dispatch(onError(utils.isPersian(message) ? message : t("errorInConnection")))
    }
}